class SizeFinderDrawer extends HTMLElement {
  constructor() {
    super();
    this.finderOpener = document.querySelector('.size-finder-drawer__opener');
    this.finderClose = this.querySelectorAll('.size-finder--close');
    this.finderContent = this.querySelector('.size-finder-drawer__content');
    this.finderOverlay = this.querySelector('.size-finder-drawer__overlay');
    this.menuDrawer = null;
  }

  connectedCallback() {
    if (!this.finderOpener) return;

    this.finderOpener.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.menuDrawer = this.finderOpener.closest('menu-drawer');
      this.openDrawer();
    });

    if (this.finderOverlay) {
      this.finderOverlay.addEventListener('click', () => this.closeDrawer());
    }

    this.finderClose.forEach(button => {
      button.addEventListener('click', () => this.closeDrawer(false));
    });

    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && this.classList.contains('is-active')) {
        this.closeDrawer();
      }
    });

    this._tabBlocker = (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
      }
    };

    this.addEventListener('keydown', this._tabBlocker, true);
  }

  openDrawer() {
    this.classList.add('is-active');
    document.body.classList.add('overflow-hidden-desktop');
    if (this.menuDrawer) this.menuDrawer.classList.add('is-hidden-by-finder');
    trapFocus(this.finderContent);
    const sizeFinder = this.querySelector('size-finder');
    if (sizeFinder && typeof sizeFinder.saveSelectedQuantity === 'function') {
      sizeFinder.saveSelectedQuantity();
    }
    this.resetSizeFinder();
  }

  closeDrawer(closeAlsoMenuDrawer) {
    this.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden-desktop');
    if (this.menuDrawer) {
      this.menuDrawer.classList.remove('is-hidden-by-finder');
    }

    if (closeAlsoMenuDrawer) {
      this.closeAlsoMenuDrawer();
    }
    removeTrapFocus(this.finderOpener);
    this.resetAllMedia();
    this.resetSizeFinder();

    if (this._tabBlocker) {
      this.removeEventListener('keydown', this._tabBlocker, true);
      this._tabBlocker = null;
    }
  }


  closeAlsoMenuDrawer() {
    const details = this.finderOpener.closest('menu-drawer details');
    if (details) {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    }
  }

  resetAllMedia() {
    const mediaElements = this.querySelectorAll('deferred-media');
    mediaElements.forEach(media => {
      const video = media.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.remove();
      }
      media.removeAttribute('loaded');
    });
  }

  resetSizeFinder() {
    const sizeFinder = this.querySelector('size-finder');
    if (sizeFinder && typeof sizeFinder.reset === 'function') {
      sizeFinder.reset();
    }
  }
}

if (!customElements.get('size-finder-drawer')) {
  customElements.define('size-finder-drawer', SizeFinderDrawer);
}